// extracted by mini-css-extract-plugin
export var modal = "_ui-0";
export var table = "_ui-1";